import React from 'react';
import S from './CaseACocher.module.scss';

const CaseACocher = ({
  checked = false,
  onChange = () => {},
  label = '',
  disabled = false,
  name = '',
  id = '',
  className = '',
  ...props
}) => {
  const handleChange = (e) => {
    onChange(e.target.checked);
  };

  return (
    <div className={[S.caseACocher, className].join(' ')}>
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        name={name}
        id={id}
        className={S.input}
        {...props}
      />
      {label && (
        <label htmlFor={id} className={S.label}>
          {label}
        </label>
      )}
    </div>
  );
};

export default CaseACocher;
